export class Assinatura{
  id: number;
  posicao: number;
  arquivo: File;
  nome: string;
  cargo: string;
  usuario_id: number;
  destroy: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/assinaturas/assinatura.ts